module.exports = __webpack_public_path__ + "img/youtube_logo_animated.28df5512.gif";